import { Typography } from "@mui/material";
import { ContentContainer } from "./ContentContainer";
import { SubSectionHeader } from "./SubSectionHeader";
import { Tag } from "./ExperienceModal";

const languages = ["Python", "Java", "SQL", "R"];

export const Languages = () => {
  return (
    <ContentContainer id="otherLanguages">
      <div style={{ textAlign: "left", margin: 24 }}>
        <SubSectionHeader
          title="Other Languages"
          subtitle="Some other skills and languages I've learned"
        />
        <div style={{ display: "flex", columnGap: 10, marginTop: 8 }}>
          {languages.map((item, index) => (
            <Tag text={item} bgColor={"black"} />
          ))}
        </div>
      </div>
    </ContentContainer>
  );
};
